/* global */

const ROW_TEMPLATE = '.js-alternative-keyword-template';

const alternativeKeywords = {
  /**
   * @param {HTMLElement} node
   * @return {Void}
   */
  create(node) {
    this.node = node;
    this.rows = this.getRows();
    this.addBtn = node.querySelector('.js-add-row');
    this.template = document.querySelector(ROW_TEMPLATE).innerHTML;

    this.createEvents();
  },

  createEvents() {
    // Listen for clicks on the add row button
    this.addBtn.addEventListener('click', () => {
      // Get the last row
      const last = this.rows[this.rows.length - 1];

      const clone = document.createElement('div');
      clone.className = 'form-group js-duplicate-row';
      clone.innerHTML = this.template.replaceAll('##i##', this.rows.length);

      window.pubsub.publish('components:evaluate');

      // Add the row after the last row
      last.parentNode.insertBefore(clone, last.nextSibling);
    });

    // Listen for all clicks on the container
    this.node.addEventListener('click', (e) => {
      // Check if we've clicked on the remove button
      if (e.target.className.indexOf('.js-remove-row'.replace(/^\./, '')) < 0) {
        return true;
      }

      e.preventDefault();
      const { target } = e;
      const parent = target.parentNode;

      // Remove the row
      parent.parentNode.removeChild(parent);

      return true;
    });
  },

  /**
   * Get an array of row nodes
   * @return {Array} List of row DOM nodes
   */
  getRows() {
    return this.nodeListToArray(document.querySelectorAll('.js-duplicate-row'));
  },

  /**
   * Tiny helper function to transform NodeList to an array
   * @param {NodeList} els List of nodes
   * @param {Array} Array of nodes
   */
  nodeListToArray(els) {
    return Array.prototype.slice.call(els);
  },
};

export default alternativeKeywords;
